//100vh Fix
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});



$(document).ready(function(){


  //Product Slideswhow
  const productSwiper = new Swiper('.product_images_mobile.with-swiper .swiper-container', {
    loop: true,
    lazy: {
      loadPrevNext: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    }
  });

  //Hover Slideshow
  $('.product_thumb .swiper-container').each(function(){
    var $this = $(this);
    var $hoverSwiper = new Swiper('.product_thumb .swiper-container', {
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 1000
      },
      on: {
        
      }
    });
    //$hoverSwiper.autoplay.stop();
    $this.hover(function(){
      //$hoverSwiper.autoplay.start();
      $(this).parents('.product_thumb').addClass('do-hover');
    }, function(){
      //$hoverSwiper.autoplay.stop();
      $(this).parents('.product_thumb').removeClass('do-hover');
    })

  })

  //Cart Drawer
  $('.toggle_cart').click(function(e){
    e.preventDefault();
    $('#side_cart, #cart_mask,#cart_suggestions').toggleClass('open');
    $('body').removeClass('search_open');
    $('body').removeClass('menu_open');
  });

  //Ajax Remove Button
  $('body').on('click','.remove_link',function(event){
    event.preventDefault();
    var $variant = $(this).attr('data-variant');
    $('#cart_contents').addClass('loading');

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']=0',
      dataType: 'json',
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count, .cart_count').html(cart.item_count);
        } );
      }
    });
  });

  //Wrap Blog/Page videos in class
  $(".page_wrap.article_content iframe").wrap("<div class='article_video'/>");

  //Wrap Big Tables in wrapper on pages like Truck Size Guide
  $('.page_content table').wrap("<div class='table_wrap'></div>");

  //Toggle Socials
  $('.toggle_socials').click(function(e){
    $('body').toggleClass('socials_open');
  });

  //Toggle Privacy
  $('.toggle_privacy').click(function(e){
    $('body').toggleClass('privacy_open');
  });

  //Toggle Copyright
  $('.toggle_copyright').click(function(e){
    $('body').toggleClass('copyright_open');
  });

  //Radio Button Variants
  var radioArray = document.querySelectorAll('input[type="radio"]');
  var checkedArray = [];

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'GBP'
  });
  for (let k = 0; k < radioArray.length; k++) {
    radioArray[k].addEventListener('change', function() {
      var checkedValues = document.querySelectorAll('input[type="radio"]:checked');
      checkedArray = Array.from(checkedValues, radio => radio.value);

      for (let l = 0; l < variantsArray.length; l++) {
        if ((JSON.stringify(checkedArray)) == (JSON.stringify(variantsArray[l].options))) {
          var priceString = variantsArray[l].price.toString();
          var id = variantsArray[l].id;
          var available = variantsArray[l].available;
          
          var featuredImagePosition = variantsArray[l].featured_image.position;
          if(featuredImagePosition) {
            var goTo = $("#product_images_desktop li").eq(featuredImagePosition - 1)[0];
            goTo.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            productSwiper.slideTo(featuredImagePosition);
          }
          
          document.querySelector('.unit-price').textContent = formatter.format(priceString / 100);
          document.querySelector('#variant_id').value = id;
          if (available == false) {
            $('#add_to_cart_button').prop('disabled', true).text("Sold Out");
            $('.klaviyo-bis-trigger').show();
          } else {
            $('#add_to_cart_button').prop('disabled', false).text("+ Add to Bag");
            $('.klaviyo-bis-trigger').hide();
          }
        }
      }

    })
  }

  
});